// src/ConnectCanvas.jsx
import { useState } from "react";
import { auth } from "./firebase";

export default function ConnectCanvas() {
  const [token, setToken] = useState("");
  const [status, setStatus] = useState("");

  const handleSave = async (e) => {
    e.preventDefault();
    setStatus("");

    const user = auth.currentUser;
    if (!user) {
      setStatus("You must be logged in first.");
      return;
    }

    try {
      const res = await fetch(
        "https://us-central1-myco-tech.cloudfunctions.net/saveCanvasToken",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.uid,
            canvasToken: token,
          }),
        }
      );

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Failed to save token");
      }

      setStatus("Saved ✔");
    } catch (err) {
      console.error("saveCanvasToken error:", err);
      setStatus("Error saving token");
    }
  };

  return (
    <div
      style={{
        marginTop: 20,
        padding: 12,
        border: "1px solid #ddd",
        borderRadius: 8,
        maxWidth: 400,
      }}
    >
      <h3>Connect Canvas</h3>
      <p style={{ fontSize: 14 }}>
        Paste your Canvas <b>Developer Token</b> below.
      </p>

      <form onSubmit={handleSave} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <textarea
          rows={3}
          placeholder="Canvas developer token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          required
        />

        <button type="submit">Save Canvas Token</button>
      </form>

      {status && (
        <p style={{ marginTop: 8, fontSize: 14 }}>
          {status}
        </p>
      )}
    </div>
  );
}
